import React from 'react';
import classNames from 'classnames';
import { Divider } from '../../../ui';
import styles from './dividers.module.scss';
export const HorizontalDivider = ({ className, type = 'default', 'data-hook': dataHook, }) => (React.createElement(Divider, { className: classNames(styles.root, styles[`type-${type}`], className), "data-hook": dataHook }));
export const BulletDivider = ({ className }) => (React.createElement("div", { className: classNames(styles.bulletDivider, className) }, "\u2022"));
//# sourceMappingURL=dividers.js.map